module.exports = __webpack_public_path__ + "static/flags/BR-65f8549c31fc2f352439e67f58a04a98.gif";